module.exports = __webpack_public_path__ + "img/target_pin.9d1e408b.svg";